import React from 'react'

const FinalizationBanner = () => {
  return (
    <div>
      <>
        <div className="container-fluild overflow-hidden">
          <section className="nebopan">
            <div
              className="nebopan-banner-section"
              style={{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/assets/images/maxresdefault-5.png")' }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12 text-center">
                    <p className=" centered-p">Finalization</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section className=" overflow-hidden page-banner">
          <div className="container">
            <div className="d-flex">
              <div className="m-auto">
                <div className="breadcrumbss">
                  <div className="breadcrumb-item passed">Essence</div>
                  <div className="breadcrumb-item passed">Structure</div>
                  <div className="breadcrumb-item passed">Accessoires</div>
                  <div className="breadcrumb-item active">Finalisation</div>
                </div>
                <div className="title">
                  <h2 className="">Votre devis est prêt</h2>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>

    </div>
  )
}

export default FinalizationBanner